let autoplay = null;
let interval = null;

let slideshow = null;
let current = 0;
let nextSlide = 1;
const slidesArr = [];

function slide() {
    if (autoplay === 'true') {
        slideshow = setInterval(() => {
            transition('.new-slide__slide', slidesArr[nextSlide], 'new-slide--hide');
            transition('.new-slide__dot', `[data-dot="${nextSlide}"]`, 'new-slide__dot--hide');

            current = nextSlide;
            nextSlide = nextSlide + 1 >= slidesArr.length ? 0 : nextSlide + 1;
        }, interval + 1000);
    }
}

function transition(elOne, elTwo, change) {
    Array.from(document.querySelectorAll(elOne)).forEach((k) => k.classList.add(change));
    document.querySelector(elTwo).classList.remove(change);
}

function slideDots(dotNum) {
    clearInterval(slideshow);

    transition('.new-slide__slide', `[data-slides="${dotNum}"]`, 'new-slide--hide');
    transition('.new-slide__dot', `[data-dot="${dotNum}"]`, 'new-slide__dot--hide');

    current = parseInt(dotNum, 10);
    nextSlide = current + 1 >= slidesArr.length ? 0 : current + 1;
}

function slideArrows(arrow) {
    clearInterval(slideshow);

    if (arrow === 'right') {
        transition('.new-slide__slide', `[data-slides="${nextSlide}"]`, 'new-slide--hide');
        transition('.new-slide__dot', `[data-dot="${nextSlide}"]`, 'new-slide__dot--hide');

        current = nextSlide;
        nextSlide = current + 1 >= slidesArr.length ? 0 : current + 1;
    } else {
        if (current === 0) {
            current = slidesArr.length - 1;
            nextSlide = 0;
        } else {
            current -= 1;
            nextSlide = nextSlide - 1 <= 0 ? slidesArr.length - 1 : nextSlide - 1;
        }

        transition('.new-slide__slide', `[data-slides="${current}"]`, 'new-slide--hide');
        transition('.new-slide__dot', `[data-dot="${current}"]`, 'new-slide__dot--hide');
    }
}

function init() {
    autoplay = document.getElementsByClassName('js--autoplay')[0].innerHTML;
    interval = parseInt(document.getElementsByClassName('js--interval')[0].innerHTML, 10);

    const _slider = document.getElementsByClassName('new-slide')[0];
    const _dot = Array.from(document.getElementsByClassName('new-slide__dot'));
    const _arrow = Array.from(document.getElementsByClassName('new-slide__arrow'));
    const _slidebtn = Array.from(document.getElementsByClassName('new-slide__btn'));
    const slideCount = parseInt(document.getElementsByClassName('js--slideCount')[0].innerHTML, 10);

    for (let i = 0; i < slideCount; i += 1) {
        slidesArr.push(`[data-slides="${i}"]`);
    }
    slide();

    _slider.addEventListener('mouseover', () => clearInterval(slideshow));
    _slider.addEventListener('mouseout', () => slide());

    _dot.forEach((k) =>
        k.addEventListener('click', (e) => {
            if (e.target.classList.contains('new-slide__dot--hide')) {
                slideDots(e.target.getAttribute('data-dot'));
            }
        }),
    );

    _arrow.forEach((k) =>
        k.addEventListener('click', (e) => slideArrows(e.target.getAttribute('data-arrow'))),
    );
    _slidebtn.forEach((k) => k.addEventListener('click', (e) => e.target.getAttribute('href')));
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/portal-slider.js